import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import TabsHeader from '../../../common/layout/tab/tabsHeader'
import { update } from '../duck'
import FormDefault from './FormDefault'
import FormUserProfile from './FormUserProfile'
import FormLedger from './FormLedger'
import { create as createUserProfile } from '../duck/userProfile.duck'
import { formatBrlCents, formatDateTime } from '../../helpers/format'

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: false,
            docFormOpened: false
        }
    }

    render() {
        const itemId = this.props.user.id;
        const user = this.props.user || {}

        return (
            <>
                <div className="card card-primary">
                    <TabsHeader>
                        <li className="nav-item">
                            <a id='homeNavLink' className={`nav-link active`} data-toggle="tab" href="#home">Usuário</a>
                        </li>
                        <li className="nav-item">
                            <a id='menu1NavLink' className={`nav-link ${this.props.isEdit ? `` : `disabled`}`} data-toggle="tab" href="#menu1">Perfis</a>
                        </li>
                        <li className="nav-item">
                            <a id='menuLedgerNavLink' className={`nav-link ${this.props.isEdit ? `` : `disabled`}`} data-toggle="tab" href="#menuLedger">Extrato de créditos</a>
                        </li>
                    </TabsHeader>
                    <div className='card-body'>
                        {itemId ? (
                            <div className="row mb-3 text-muted">
                                <div className="col-md-4">
                                    <strong>Criado em:</strong> {formatDateTime(user.created_at)}
                                </div>
                                <div className="col-md-4">
                                    <strong>Último acesso:</strong> {formatDateTime(user.last_access)}
                                </div>
                                <div className="col-md-4">
                                    <strong>Saldo:</strong> {formatBrlCents(user.balance_cents)}
                                    {' · '}
                                    <a href="#menuLedger" data-toggle="tab" onClick={() => {
                                        const link = document.getElementById('menuLedgerNavLink')
                                        if (link) link.click()
                                    }}>Ver extrato</a>
                                </div>
                            </div>
                        ) : null}
                        <div className="tab-content">
                            <div className="tab-pane container active" id="home">
                                <FormDefault />
                            </div>
                            <div className="tab-pane container fade" id="menu1">
                                <FormUserProfile submitLabel='Adicionar' submitClass='primary'
                                    onCreate={this.props.createUserProfile} />
                            </div>
                            <div className="tab-pane container fade" id="menuLedger">
                                <FormLedger key={itemId || 'new'} userId={itemId} />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => ({
    isEdit: state.form.userForm && state.form.userForm.initial && state.form.userForm.initial.id ? state.form.userForm.initial.id : false,
    user: state.form.userForm && state.form.userForm.initial ? state.form.userForm.initial : false,
})

const mapDispatchToProps = dispatch => bindActionCreators({
    update, createUserProfile
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Form)
